module.exports = __webpack_public_path__ + "static/flags/SL-26770cf5c1e744a94a6274c047db163a.gif";